import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Menu {
  name: string;
  api_token: string;
}

export interface MenuInfo {
  errors: unknown;
  listMenu: Menu;
  isAuthenticated: boolean;
}

@Module
export default class MenuModule extends VuexModule implements MenuInfo {
  errors = {};
  listMenu = {} as Menu;
  menuInfo = {};
  isAuthenticated = !!JwtService.getToken();

  get getListMenu() {
    return this.listMenu;
  }

  @Mutation
  [Mutations.MENU_LIST_DATA](listMenu) {
    this.listMenu = listMenu;
  }

  get getMenuDetail() {
    return this.menuDetail;
  }

  @Mutation
  [Mutations.MENU_DETAIL_DATA](menuDetail) {
    this.menuDetail = menuDetail;
  }

  @Action
  [Actions.MENU_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("menu/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.MENU_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.MENU_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/menu", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.MENU_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.MENU_LIST](payload) {
    return ApiService.post("menu", payload)
      .then((data) => {
        this.context.commit(Mutations.MENU_LIST_DATA, data);
        this.context.commit(Mutations.SET_ERROR, {});
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }

  get getFunctionList() {
    return this.functionList;
  }

  @Mutation
  [Mutations.FUNCTION_LIST_DATA](functionList) {
    this.functionList = functionList;
  }

  @Action
  [Actions.FUNCTION_LIST]() {
    return ApiService.post("menu/list-function")
      .then((data) => {
        this.context.commit(Mutations.FUNCTION_LIST_DATA, data);
        this.context.commit(Mutations.SET_ERROR, {});
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.MENU_DRAGDROP](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("menu/dragdrop", payload)
        .then((data) => {
          this.context.commit(Mutations.MENU_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.MENU_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/menu", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.MENU_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.MENU_DETAIL](payload) {
    return ApiService.getDataDetail("/menu", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.MENU_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
